import axios from 'axios'

axios.defaults.timeout = 60000
axios.defaults.baseURL = 'https://xm.miaoxianghuandian.com:8021/guanwang/'
    /**
     *
     * 请求拦截
     */
axios.interceptors.request.use(config => {

    return config
}, error => {

    return Promise.reject(error)
})

axios.interceptors.response.use(
    response => {

        return response.data;
    },
    error => {
        console.log(error)

        return Promise.reject(error)
    });


export default axios


// WEBPACK FOOTER //
// ./src/axios/index.js